const SubCategory = {

    // FIELDS
    "name": "Name",
    "image": "Image",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    "category": "Category",

    // PAGE HEADER
    "category": "Sub Category",

    // ERROR
    "error_name": "Enter Name",
    "error_image": "Select Image",
    "error_description": "Enter Description",
    "error_status": "Select Status",
    "error_category": "Select Category",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_image": "IMAGE",
    "table_description": "DESCRIPTION",
    "table_category": "CATEGORY",
    "table_status": "STATUS",

    // OTHER
    "current_image": "Current Image",

}

export default SubCategory;

